<template>
  <div class="modal-component-body"><slot /></div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.modal-component-body {
  padding: 16px;
  @include point-md {
    padding: 24px;
  }
}
</style>
